export default __webpack_public_path__ + "static/media/payjak-picturemark-d.1a3ff057.svg";